import { useState } from "react";
import { Button } from "@mui/material";
import { ApiRequest } from "GlobalFunctions";
import { PiCaretRightBold, PiHandPeace } from "react-icons/pi";
import { enqueueSnackbar } from "notistack";


interface CancelSubscriptionProps {
    subscriptionData: any;
    onGoBack: () => void;
    onCancelSuccess: () => void;
}

export default function CancelSubscription(props: CancelSubscriptionProps) {
    const { subscriptionData, onGoBack, onCancelSuccess } = props;
    const [loading, setLoading] = useState(false);
    const [cancelled, setCancelled] = useState(false);

    const formatDate = (dateString: string) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', { 
            month: 'long', 
            day: 'numeric', 
            year: 'numeric',
            timeZone: 'UTC'
        });
    };

    const submitCancelSubscription = () => {
        setLoading(true);
        ApiRequest({
            url: '/subscriptions/cancel',
            method: 'POST',
            body: {
                subscription_id: subscriptionData?.subscription_id,
                cancel_reason: ''
            },
            setResponse: (response: any) => {
                setLoading(false);
                if (response.status === "success") {
                    setCancelled(true);
                } else {
                    enqueueSnackbar(response.message || "Failed to cancel subscription", { variant: 'error' });
                }
            }
        });
    };

    return (
        <div className="pc-cancel-subscription">
            <div className="pc-cancel-breadcrumb">
                <span>BILLING</span>
                <PiCaretRightBold />
                <span>CANCEL</span>
            </div>

            {cancelled ? (
                <div className="pc-cancel-success-overlay">
                    <PiHandPeace className="pc-cancel-success-icon" />
                    <h1 className="pc-cancel-success-title">Cancelation Successful</h1>
                    <p className="pc-cancel-success-message">Your account with {subscriptionData?.company_name} has been canceled</p>
                    <Button
                        variant="contained"
                        onClick={onCancelSuccess}
                        fullWidth
                        style={{
                            backgroundColor: subscriptionData?.primary_color || '#303030',
                            color: '#fff',
                            borderRadius: '10px',
                            padding: '10px 40px',
                            fontSize: '16px',
                            textTransform: 'none',
                            marginTop: '30px',
                            maxWidth: '400px'
                        }}
                    >
                        Back To Account
                    </Button>
                </div>
            ) : (
                <div className="pc-update-form">
                    <h1 className="pc-cancel-title">Cancel Your Subscription</h1>

                    <div className="pc-cancel-product-info">
                        <div className="pc-cancel-product-name">{subscriptionData?.products?.[0]?.product_name}</div>
                        <div className="pc-cancel-product-price">USD${subscriptionData?.total_amount} per {subscriptionData?.products?.[0]?.frequency?.toLowerCase()?.replace('ly', '')}</div>
                    </div>

                    <div className="pc-cancel-message">
                        <p>Your subscription will be canceled, but is still available until the end of your billing period on {formatDate(subscriptionData?.latest_next_payment_date)}.</p>
                        <p>If you change your mind, you can renew your subscription.</p>
                    </div>

                    <div className="pc-cancel-actions">
                        <Button
                            variant="contained"
                            className="pc-cancel-btn-confirm"
                            onClick={submitCancelSubscription}
                            disabled={loading}
                            fullWidth
                            style={{
                                backgroundColor: subscriptionData?.primary_color || '#303030',
                                color: '#fff',
                                borderRadius: '10px',
                                padding: '10px 40px',
                                fontSize: '16px',
                                textTransform: 'none',
                            }}
                        >
                            Cancel
                        </Button>

                        <Button
                            variant="outlined"
                            className="pc-cancel-btn-goback"
                            onClick={onGoBack}
                            fullWidth
                            style={{
                                borderColor: subscriptionData?.primary_color || '#303030',
                                color: subscriptionData?.primary_color || '#303030',
                                borderRadius: '10px',
                                padding: '10px 40px',
                                fontSize: '16px',
                                textTransform: 'none',
                                marginTop: '15px'
                            }}
                        >
                            Go back
                        </Button>
                    </div>
                </div>
            )}
        </div>
    );
}
